import React, { Fragment } from "react";


const NotFound = () => {

    return (
        <Fragment>
            <div className="text-center mt-5 mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="50" height="50">
                    <g id="_01_align_center" data-name="01 align center">
                        <polygon points="15.293 7.293 12 10.586 8.707 7.293 7.293 8.707 10.586 12 7.293 15.293 8.707 16.707 12 13.414 15.293 16.707 16.707 15.293 13.414 12 16.707 8.707 15.293 7.293"/>
                        <path d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z"/>
                    </g>
                </svg>
            </div>
            <h2 className="text-center mb-5">Model Form Not Found</h2>
        </Fragment>
    );
};

export default NotFound;
